import { render, staticRenderFns } from "./ErrorAlert.vue?vue&type=template&id=92a8bab2&scoped=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=ts"
export * from "./ErrorAlert.vue?vue&type=script&lang=ts"
import style0 from "./ErrorAlert.vue?vue&type=style&index=0&id=92a8bab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a8bab2",
  null
  
)

export default component.exports